import { z } from "zod/v4";

/**
 * A training group's feedback, folded into an anonymous view. Below the
 * anonymity floor the API sends `suppressed` with no numbers at all — in a
 * small group a bare count already hints at who did and did not answer — so
 * every field but `suppressed` and `count` is nullable by contract.
 */
export const ratingSummarySchema = z.object({
	average_intensity: z.number().nullable(),
	average_stars: z.number().nullable(),
	count: z.number().int(),
	notes: z.array(z.string()),
	suppressed: z.boolean(),
});

/** One training group's rolling summary in the club-wide ratings view. */
export const clubRatingSummarySchema = z.object({
	name: z.string(),
	squad_id: z.string().uuid(),
	summary: ratingSummarySchema,
});

export const clubRatingSummariesSchema = z.array(clubRatingSummarySchema);

export type RatingSummary = z.infer<typeof ratingSummarySchema>;
export type ClubRatingSummary = z.infer<typeof clubRatingSummarySchema>;
